import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import * as expertApi from '../../../../../api/expert/expert';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ConnectionsSlice } from '../../types/connections';

export const populateAllConnectionsProfiles = createAsyncThunk('connections/populate/list', async () => {
    const response = await expertApi.getAllConnectionsProfiles();
    return {
        profiles: response,
    };
});

const reducer = (builder: ActionReducerMapBuilder<ConnectionsSlice>) => {
    builder.addCase(populateAllConnectionsProfiles.fulfilled, (state, action) => {
        state.profiles = action.payload.profiles;
        state.isLoadingProfiles = false;
    });
    builder.addCase(populateAllConnectionsProfiles.pending, (state, action) => {
        state.isLoadingProfiles = true;
    });
    builder.addCase(populateAllConnectionsProfiles.rejected, (state, action) => {
        state.isLoadingProfiles = false;
    });
};

export default reducer;
